"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasActiveTour = exports.useActiveTour = void 0;
const react_1 = __importDefault(require("react"));
const tiny_typed_emitter_1 = require("tiny-typed-emitter");
class ActiveTour extends tiny_typed_emitter_1.TypedEmitter {
    constructor() {
        super(...arguments);
        this.$activeTours = [];
    }
    addActiveTour(tour) {
        this.$activeTours = [...new Set([...this.$activeTours, tour])];
    }
    removeActiveTour(tour) {
        this.$activeTours = this.$activeTours.filter(t => t !== tour);
    }
    get hasActiveTours() {
        return !!this.$activeTours.length;
    }
}
if (!global.reactToursActiveTour) {
    ;
    global.reactToursActiveTour = new ActiveTour();
}
const activeTour = global.reactToursActiveTour;
function useActiveTour(tour) {
    react_1.default.useEffect(() => {
        if (tour) {
            const tourId = (Math.random() * 1000).toString();
            activeTour.addActiveTour(tourId);
            return () => activeTour.removeActiveTour(tourId);
        }
    }, [tour]);
}
exports.useActiveTour = useActiveTour;
function useHasActiveTour() {
    const [hasActiveTour, setHasActiveTour] = react_1.default.useState(activeTour.hasActiveTours);
    react_1.default.useEffect(() => {
        const handler = () => {
            setHasActiveTour(activeTour.hasActiveTours);
        };
        activeTour.on('toursChanged', handler);
        return () => {
            activeTour.off('toursChanged', handler);
        };
    }, []);
    return hasActiveTour;
}
exports.useHasActiveTour = useHasActiveTour;
//# sourceMappingURL=useActiveTour.js.map